import { useProfilePicture } from "hooks/useProfilePicture";

export type ProfilePictureProps = {
    width: number | string;
    height: number | string;
    additionalStyles?: React.CSSProperties;
    fallbackSize?: number | string | undefined;
}

export default function ProfilePicture({ width, height, additionalStyles, fallbackSize}: ProfilePictureProps) {
    const { rawUrl, hasProfilePicture } = useProfilePicture();

    if (!hasProfilePicture) {
        return (
            <div
              className="rounded-circle bg-light d-flex align-items-center justify-content-center text-secondary flex-shrink-0"
              style={{ width: width, height: height, ...additionalStyles }}
            >
                <i className={`fas fa-user ${fallbackSize ? `fa-${fallbackSize}` : ''}`} />
            </div>
        )
    }
    return (
        <img
            alt="Kullanıcı"
            className="rounded-circle object-fit-cover"
            height={height}
            width={width}
            src={rawUrl!}
            style={{ objectFit: 'cover', width: width, height: height, ...additionalStyles }}
        />
    )
}